import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types';
import Tag from './Tag';

export default function NewsRow({ item }: { item: NewsItem }) {
  return (
    <article className="group flex gap-3 md:gap-4 py-4 border-b border-background-200 last:border-b-0">
      <Link to={`/detail/news/${item.id}`} className="shrink-0 w-28 h-20 md:w-36 md:h-24 rounded-md overflow-hidden cursor-pointer">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-col min-w-0 flex-1">
        <Link to={`/detail/news/${item.id}`} className="cursor-pointer">
          <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h3>
        </Link>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed hidden sm:block">{item.summary}</p>
        <div className="mt-auto pt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-user-line"></i>
            {item.author}
          </span>
          {item.tags.slice(0, 2).map((tag) => (
            <Tag key={tag} label={tag} variant="primary" />
          ))}
        </div>
      </div>
    </article>
  );
}